module.exports = __webpack_public_path__ + "img/location.cac1c3f7.svg";